import { z } from 'zod';

export const holidaySchema = z.object({
  id: z.string(),
  name: z.string(),
  date: z.string(),
  country: z.string().nullable(),
  isReadOnly: z.boolean(),
  agencyId: z.string(),
  clientIds: z.array(z.string()),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type HolidaySchema = z.infer<typeof holidaySchema>;
